import { callAPIWhiteToken } from "../config/api";

const PATH_API = process.env.REACT_APP_API;

export async function postDataPages(data: any) {
    const url = `${PATH_API}/sosial-media/filtered`;
    return await callAPIWhiteToken({
        url,
        method: "POST",
        data: data
    });
}
